import UserInfo from '../../../../../../../components/UserInfo/UserInfo';
import { IRequesterInfo } from '../../../../../../../types/stockOrders';
import './RequestorInfo.scss';

const RequestorInfo = ({ requesterInfo }: { requesterInfo: IRequesterInfo }) => {
  
  return (
    <div className="requesterInfo">
      <span className="requesterInfoTitle">Información del solicitante</span>
      <div className="requesterInfoContainer">
        <UserInfo
          profilePhoto={requesterInfo?.photoUrl ?? null}
          firstName={requesterInfo?.name}
          email={requesterInfo?.email}
          imageProps={{
            style: {
              objectFit: 'contain',
              borderRadius: '100%',
              width: '40px',
              height: '40px'
            }
          }}
          bordPhotoSize="s40"
        />
      </div>
    </div>
  );
};

export default RequestorInfo;
